module.exports = __webpack_public_path__ + "img/Skirt-Front-B7-Da-Fc-Hc-Ia.aab313fa.png";